import { apiHelper } from 'shared';

import { http } from './http';

const controllerName = 'orders';

class Orders {
  get(paging, sorting, filters) {
    let queryString = '';
    queryString = apiHelper.composeQueryString({ ...paging, ...sorting, ...filters });

    return http.get(`/${controllerName}${queryString}`, {});
  }

  getById(id) {
    return http.get(`/${controllerName}/${id}`, {});
  }

  updateStatusCreated(id) {
    return http.patch(`/${controllerName}/${id}/status/created`);
  }

  export(sorting, filters) {
    let queryString = '';
    queryString = apiHelper.composeQueryString({ ...sorting, ...filters });

    return http.get(`/${controllerName}/export${queryString}`, {});
  }
}

export const orders = new Orders();
